export default {
  inventories: [],
  inventoriesDealer: [],
  top10Items: [],
}
